<template>
  <div id="gameOverView">
    <div id="gameOverContentContainer">
      <div id="gameOverSideBanner">
<!--         <div class="side-banner-item">
          YOUR RANK:<br/>
          <span class="highlighted-banner-info">#{{ rankedUsers.find(rankedUser => rankedUser.id === currentUser.id).curRank }}</span>
        </div> -->
        <div class="side-banner-item">
          ROUND SCORE:<br/><span class="highlighted-banner-info">{{ getUserRoundScore() }}</span>
        </div>
      </div>
      <div id="gameOverMessageContainer" v-if="(currentUser.userType === rounds[currentRound].roundType)">
        <div id="gameOverMessageContent">
          {{ ((currentRound === (rounds.length - 1)) ? 'Thanks for playing!' : 'You\'ve completed this round!') }}<br/>
          {{ ((currentRound === (rounds.length - 1)) ? '' : 'Please wait for the next round to begin.') }}
        </div>
<!--         <Transition name="fade" mode="out-in">
          <div id="gameOverLeaderboardButton" class="game-button" @click="toggleLeaderboardModal" v-if="showLeaderboardButton">
            VIEW LEADERBOARD
          </div>
        </Transition> -->
      </div>
      <div id="gameOverMessageContainer" v-else>
        <div id="gameOverMessageContent" v-if="(rounds[currentRound].roundType === 'Team')">
          This next round is not meant for individuals. Please go to your Pit Crew table and select your team's user login on the laptop on the table to log in for the next round. 
        </div>
        <div id="gameOverMessageContent" v-else>
          This round is not meant for teams.  Please log out and select your individual user when logging in to participate.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Howl } from 'howler'

export default {
  name: 'GameOver',
  components: {

  },
  computed: {
    ...mapGetters([
      'moduleTitle',
      'moduleAssetFolderName',
      'currentUser',
      'currentView',
      'currentRound',
      'rounds',
      'users',
    ]),
    rankedUsers(){
      const theGameOverView = this;
      let rankedUsers = [...theGameOverView.users];
      // rankedUsers.sort((userA, userB) => {
      //   // first sort by score
      //   if(userA.score < userB.score){
      //     return 1;
      //   }
      //   if(userA.score > userB.score){
      //     return -1;
      //   }
      //   // then sort by last name if there's a tie
      //   const nameA = userA.lastName.toLowerCase();
      //   const nameB = userB.lastName.toLowerCase();
      //   if(nameA < nameB){
      //     return -1;
      //   }
      //   if(nameA > nameB){
      //     return 1;
      //   }
      //   return 0;
      // });
      // // set up ranking numbers with pseudo golf leaderboard display
      // let curRank = 1;
      // let isTied = false;
      // rankedUsers.forEach((rankedUser, rankedUserIndex) => {
      //   isTied = false;
      //   if(rankedUserIndex > 0){
      //     if(rankedUser.score < rankedUsers[(rankedUserIndex - 1)].score){
      //       curRank++;
      //     }else{
      //       isTied = true;
      //     }
      //   }
      //   rankedUsers[rankedUserIndex].curRank = curRank;
      //   rankedUsers[rankedUserIndex].isTied = isTied;
      // })
      return rankedUsers;
    },
  },
  methods: {
    ...mapActions([
      'onResize',
      'updateCurrentView',
      'logout',
      'toggleLeaderboardModal',
      'togglePerformanceModal'
    ]),
    prettyTimestamp(timestamp){
      let formattedDate = new Date((timestamp * 1000)).toLocaleDateString('en-US');
      let formattedTime = new Date((timestamp * 1000)).toLocaleTimeString('en-US', {hour: '2-digit', minute: '2-digit'});
      return `${formattedDate}<br/>${formattedTime}`;
    },
    getUserRoundScore(){
      const theGameOverView = this;
      let userRoundQuestions = theGameOverView.currentUser.questions.filter(question => question.roundID === theGameOverView.currentRound);
      let roundScore = 0;

      if(userRoundQuestions.length > 0){
        userRoundQuestions.forEach(question => {
          roundScore += question.pointsEarned;
        });
      }

      return roundScore;
    },
  },
  mounted(){
    const theGameOverView = this;

      if(!theGameOverView.gameOverSound){
        let tempSound = new Howl({
          src: ['./assets/common/audio/fanfare.mp3'],
          volume: 1,
          onload: () => {
            theGameOverView.gameOverSound = tempSound;
            tempSound.play()
          },
          onloaderror: (id, error) => {
            console.log(error)
          }
        });
      }else{
        theGameOverView.gameOverSound.play()
      }

    // window.setTimeout(() => {
    //   theGameOverView.showStartOverButton = true;
    // }, 750)
    window.setTimeout(() => {
      theGameOverView.showLeaderboardButton = true;
    }, 750)
    window.setTimeout(() => {
      theGameOverView.showPerformanceButton = true;
    }, 1000)
  },
  data(){
    return {
      // showStartOverButton: false,
      showLeaderboardButton: false,
      showPerformanceButton: false,
      gameOverSound: null
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #gameOverView{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 80%;
    margin: 0 auto;
    max-width: 1200px;
  }

  #gameOverContentContainer{
    display: flex;
    flex-direction: row;
    width: 100%;
    align-content: center;
    justify-items: center;
  }

  #gameOverBanner{
    width: 100%;
    max-width: 500px;
    z-index: 2;
  }
  #gameOverMessageContainer{
    width: 80%;
    padding: 15px;
    padding-right: 230px;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  #gameOverMessageContent{
    color: #fff;
    text-align: center;
    line-height: 2rem;
    /*font-size: 21px;*/
    font-size: 30px;
    font-family: Arial, arial, Verdana, verdana, sans-serif;
  }
  .content-header{
    font-size: 50px;
    line-height: 1em;
    -webkit-text-stroke-color: #da91e7;
    -webkit-text-stroke-width: 4px;
  }
  .current-rank{
    font-size: 30px;
    margin-top: 20px;
  }
  .current-score{
    font-size: 25px;
    margin-top: 10px;
  }
  .thank-you{
    margin-top: 22px;
    font-size: 20px;
  }
/*  #startOverButton{
    margin-top: 50px;
  }*/


  #gameOverSideBanner{
    display: flex;
    flex-direction: column;
    align-items:center;
    justify-content: flex-start;
    padding-top: 10px;
    width: 100%;
    height: 489px;
    max-width: 233px;
    background-image: url('~@/assets/img/content_side_banner_background.png');
    background-size: contain;
    background-repeat: no-repeat;
    font-weight: bold;
    font-size: 18px;
    line-height: 1.5em;
    color: #fff;

  }

  >>> .side-banner-item .highlighted-banner-info{
    font-size: 43px;
  }

  .side-banner-item:first-child{
    margin-top: 10px;
  }

  .side-banner-item{
    text-align: center;
    margin-bottom: 20px;
  }







  #gameOverLeaderboardButton{
    margin-top: 50px;
    font-size: 24px;
    max-width: 350px;
  }

  @media screen and (max-width: 496px){
    #gameOverMessageContainer{
/*      margin-top: -75px;*/
    }
  }

  @media screen and (max-width: 489px){
    #gameOverView{
      width: 80%;
    }
  }

  @media screen and (max-width: 425px){
    #gameOverMessageContainer{
/*      margin-top: -65px;*/
    }
  }

  @media screen and (max-width: 468px){
    #gameOverView{
      width: 100%;
    }
  }

  @media screen and (max-width: 350px){
    #gameOverMessageContainer{
/*      margin-top: -55px;*/
    }
  }

  .zoom-in-out {
    animation: zoom-in-zoom-out 0.75s;
    animation-iteration-count: 1;
  }

  @keyframes zoom-in-zoom-out {
    0% {
      transform: scale(0, 0);
    }
    50% {
      transform: scale(1.25, 1.25);
    }
    100% {
      transform: scale(1, 1);
    }
  }


  @media screen and (min-width: 737px) and (max-width: 796px){
    #gameOverSideBanner{
      font-size: 16px;
      line-height: 1em;
    }
    >>> .side-banner-item .highlighted-banner-info{
      font-size: 16px;
    }
  }

  @media screen and (max-width: 736px){
    #welcomeView{
      width: 100%;
    }
    #gameOverSideBanner{
      width: 120px;
      height: 330px;
      font-size: 12px;
      line-height: 1em;
    }
    >>> .side-banner-item .highlighted-banner-info{
      font-size: 12px;
    }
    #welcomeContent{
      position: relative;
      max-width: calc(100% - 120px);
    }
  }
</style>
